/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.ori.telecomms.proto.ControlCommandHeader', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.HealthState', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.HealthState.HealthStateType', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.LatLon', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.WaypointDescription', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.WaypointDescription.WaypointType', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.WaypointId', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.WaypointList', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.LatLon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.LatLon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.LatLon.displayName = 'proto.ori.telecomms.proto.LatLon';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.LatLon.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.LatLon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.LatLon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.LatLon.toObject = function(includeInstance, msg) {
  var f, obj = {
    latitude: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    longitude: +jspb.Message.getFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.LatLon}
 */
proto.ori.telecomms.proto.LatLon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.LatLon;
  return proto.ori.telecomms.proto.LatLon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.LatLon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.LatLon}
 */
proto.ori.telecomms.proto.LatLon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.LatLon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.LatLon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.LatLon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.LatLon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.ori.telecomms.proto.LatLon.prototype.getLatitude = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.LatLon.prototype.setLatitude = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.ori.telecomms.proto.LatLon.prototype.getLongitude = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.LatLon.prototype.setLongitude = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.WaypointId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.WaypointId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.WaypointId.displayName = 'proto.ori.telecomms.proto.WaypointId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.WaypointId.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.WaypointId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.WaypointId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.WaypointId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.WaypointId}
 */
proto.ori.telecomms.proto.WaypointId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.WaypointId;
  return proto.ori.telecomms.proto.WaypointId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.WaypointId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.WaypointId}
 */
proto.ori.telecomms.proto.WaypointId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.WaypointId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.WaypointId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.WaypointId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.WaypointId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.ori.telecomms.proto.WaypointId.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.ori.telecomms.proto.WaypointId.prototype.setId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.WaypointDescription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.WaypointDescription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.WaypointDescription.displayName = 'proto.ori.telecomms.proto.WaypointDescription';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.WaypointDescription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.WaypointDescription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.WaypointDescription.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    waypointid: (f = msg.getWaypointid()) && proto.ori.telecomms.proto.WaypointId.toObject(includeInstance, f),
    coordinate: (f = msg.getCoordinate()) && proto.ori.telecomms.proto.LatLon.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.WaypointDescription}
 */
proto.ori.telecomms.proto.WaypointDescription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.WaypointDescription;
  return proto.ori.telecomms.proto.WaypointDescription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.WaypointDescription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.WaypointDescription}
 */
proto.ori.telecomms.proto.WaypointDescription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.ori.telecomms.proto.WaypointId;
      reader.readMessage(value,proto.ori.telecomms.proto.WaypointId.deserializeBinaryFromReader);
      msg.setWaypointid(value);
      break;
    case 3:
      var value = new proto.ori.telecomms.proto.LatLon;
      reader.readMessage(value,proto.ori.telecomms.proto.LatLon.deserializeBinaryFromReader);
      msg.setCoordinate(value);
      break;
    case 4:
      var value = /** @type {!proto.ori.telecomms.proto.WaypointDescription.WaypointType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.WaypointDescription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.WaypointDescription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.WaypointDescription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWaypointid();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ori.telecomms.proto.WaypointId.serializeBinaryToWriter
    );
  }
  f = message.getCoordinate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ori.telecomms.proto.LatLon.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.WaypointDescription.WaypointType = {
  UNKNOWN: 0,
  STATION: 10,
  FAVORITE: 20,
  NAMED: 30,
  INTERMEDIATE: 100
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.ori.telecomms.proto.WaypointDescription.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WaypointId waypointId = 2;
 * @return {?proto.ori.telecomms.proto.WaypointId}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.getWaypointid = function() {
  return /** @type{?proto.ori.telecomms.proto.WaypointId} */ (
    jspb.Message.getWrapperField(this, proto.ori.telecomms.proto.WaypointId, 2));
};


/** @param {?proto.ori.telecomms.proto.WaypointId|undefined} value */
proto.ori.telecomms.proto.WaypointDescription.prototype.setWaypointid = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.ori.telecomms.proto.WaypointDescription.prototype.clearWaypointid = function() {
  this.setWaypointid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.hasWaypointid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LatLon coordinate = 3;
 * @return {?proto.ori.telecomms.proto.LatLon}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.getCoordinate = function() {
  return /** @type{?proto.ori.telecomms.proto.LatLon} */ (
    jspb.Message.getWrapperField(this, proto.ori.telecomms.proto.LatLon, 3));
};


/** @param {?proto.ori.telecomms.proto.LatLon|undefined} value */
proto.ori.telecomms.proto.WaypointDescription.prototype.setCoordinate = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.ori.telecomms.proto.WaypointDescription.prototype.clearCoordinate = function() {
  this.setCoordinate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.hasCoordinate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional WaypointType type = 4;
 * @return {!proto.ori.telecomms.proto.WaypointDescription.WaypointType}
 */
proto.ori.telecomms.proto.WaypointDescription.prototype.getType = function() {
  return /** @type {!proto.ori.telecomms.proto.WaypointDescription.WaypointType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.ori.telecomms.proto.WaypointDescription.WaypointType} value */
proto.ori.telecomms.proto.WaypointDescription.prototype.setType = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.WaypointList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ori.telecomms.proto.WaypointList.repeatedFields_, null);
};
goog.inherits(proto.ori.telecomms.proto.WaypointList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.WaypointList.displayName = 'proto.ori.telecomms.proto.WaypointList';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ori.telecomms.proto.WaypointList.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.WaypointList.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.WaypointList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.WaypointList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.WaypointList.toObject = function(includeInstance, msg) {
  var f, obj = {
    utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    opareaid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    waypointsList: jspb.Message.toObjectList(msg.getWaypointsList(),
    proto.ori.telecomms.proto.WaypointDescription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.WaypointList}
 */
proto.ori.telecomms.proto.WaypointList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.WaypointList;
  return proto.ori.telecomms.proto.WaypointList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.WaypointList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.WaypointList}
 */
proto.ori.telecomms.proto.WaypointList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpareaid(value);
      break;
    case 3:
      var value = new proto.ori.telecomms.proto.WaypointDescription;
      reader.readMessage(value,proto.ori.telecomms.proto.WaypointDescription.deserializeBinaryFromReader);
      msg.addWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.WaypointList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.WaypointList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.WaypointList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.WaypointList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOpareaid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWaypointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.ori.telecomms.proto.WaypointDescription.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.ori.telecomms.proto.WaypointList.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.WaypointList.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string opAreaId = 2;
 * @return {string}
 */
proto.ori.telecomms.proto.WaypointList.prototype.getOpareaid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.ori.telecomms.proto.WaypointList.prototype.setOpareaid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated WaypointDescription waypoints = 3;
 * @return {!Array<!proto.ori.telecomms.proto.WaypointDescription>}
 */
proto.ori.telecomms.proto.WaypointList.prototype.getWaypointsList = function() {
  return /** @type{!Array<!proto.ori.telecomms.proto.WaypointDescription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ori.telecomms.proto.WaypointDescription, 3));
};


/** @param {!Array<!proto.ori.telecomms.proto.WaypointDescription>} value */
proto.ori.telecomms.proto.WaypointList.prototype.setWaypointsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.ori.telecomms.proto.WaypointDescription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ori.telecomms.proto.WaypointDescription}
 */
proto.ori.telecomms.proto.WaypointList.prototype.addWaypoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.ori.telecomms.proto.WaypointDescription, opt_index);
};


proto.ori.telecomms.proto.WaypointList.prototype.clearWaypointsList = function() {
  this.setWaypointsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.ControlCommandHeader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.ControlCommandHeader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.ControlCommandHeader.displayName = 'proto.ori.telecomms.proto.ControlCommandHeader';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.ControlCommandHeader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.ControlCommandHeader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.ControlCommandHeader.toObject = function(includeInstance, msg) {
  var f, obj = {
    utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    commandid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    commanderid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.ori.telecomms.proto.ControlCommandHeader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.ControlCommandHeader;
  return proto.ori.telecomms.proto.ControlCommandHeader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.ControlCommandHeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.ControlCommandHeader}
 */
proto.ori.telecomms.proto.ControlCommandHeader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCommandid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommanderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.ControlCommandHeader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.ControlCommandHeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.ControlCommandHeader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCommandid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCommanderid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 commandId = 2;
 * @return {number}
 */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.getCommandid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.setCommandid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string commanderId = 3;
 * @return {string}
 */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.getCommanderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.ori.telecomms.proto.ControlCommandHeader.prototype.setCommanderid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.HealthState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.HealthState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.HealthState.displayName = 'proto.ori.telecomms.proto.HealthState';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.HealthState.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.HealthState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.HealthState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.HealthState.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.HealthState}
 */
proto.ori.telecomms.proto.HealthState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.HealthState;
  return proto.ori.telecomms.proto.HealthState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.HealthState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.HealthState}
 */
proto.ori.telecomms.proto.HealthState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ori.telecomms.proto.HealthState.HealthStateType} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.HealthState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.HealthState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.HealthState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.HealthState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.HealthState.HealthStateType = {
  NOMINAL: 0,
  INITIALIZING: 1,
  DEGRADED: 2,
  CRITICAL: 3,
  UNKNOWN: 255
};

/**
 * optional HealthStateType value = 1;
 * @return {!proto.ori.telecomms.proto.HealthState.HealthStateType}
 */
proto.ori.telecomms.proto.HealthState.prototype.getValue = function() {
  return /** @type {!proto.ori.telecomms.proto.HealthState.HealthStateType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.ori.telecomms.proto.HealthState.HealthStateType} value */
proto.ori.telecomms.proto.HealthState.prototype.setValue = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


goog.object.extend(exports, proto.ori.telecomms.proto);
